import { Edge } from "./edge.js"
import { BlockchainNetwork } from "../constants.js"

export enum EntityType {
    application = 'Application',
    bridge = 'Bridge',
    cex = 'Centralized Exchange',
    dex = 'Decentralized Exchange',
    gambling = 'gambling',
    misc = 'Misc',
    nft = 'Nft',
    nft_marketplace = 'Nft-Marketplace',
    origin = 'origin',
    privacy = 'Privacy',
    scaling = 'Blockchain-Scaling',
    smart_contract = 'Smart-Contract-Platform',
    stable_coin = 'Stablecoin',
    synthetic = 'synthetic',
    token = 'Token',
    wallet = 'Wallet',
    yield = 'Yield',
    zero = 'Zero Address',
    burn = 'Burn',
    mint = 'Mint',
}

export type Label = {
    Label: string,
}

export type Address = {
    Address: string,
    Excluded?: boolean,
    Blockchain: BlockchainNetwork,
    Labels: Label[] | null,
};

export type Entity = {
    _id?: string,
    ID: string,
    Name: string,
    Type: EntityType,
    AddressesLabeled: Address[],
    Depth?: number
}

export type SplitEntity = {
    OriginalID: string,
    ID: string,
    Depth?: number
}

export function isEntity(
    record: Entity | Edge | undefined
): record is Entity {
    return !!record && 'ID' in record
}
